<template lang="html">
  <root class="admin-country-edit">

    <admin-nav></admin-nav>
    <page-header name="Edit country" :count="false"></page-header>

    <!-- Form -->
    <div class="container">
      <div class="row">
        <div class="col m6">
          <div class="row">
            <div class="col m12">
              <div class="mui-textfield">
                <label>Hotline</label>
                <input type="text" v-model="country.hotline">
              </div>
            </div>
          </div>
        </div>

        <div class="col m6">
          <table class="bottom-line">
            <tbody>
              <tr>
                <th>Hotline</th>
                <td>{{country.hotline}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row">
        <div class="col m4 offset-m4">
          <a class="waves-effect waves-light btn" @click="updateCountry" :disabled="isSending">Update</a>
        </div>
      </div>
    </div>
  </root>
</template>

<script>
import * as firebase from 'firebase'

export default {
  data () {
    return {
      countryKey: '',
      country: {
        hotline: '',
      },
      isSending: false,
    }
  },

  methods: {

    // Collect
    collectCountry() {
      this.countryKey = this.$route.params.countryKey

      firebase.database ()
        .ref('countries/' + this.countryKey)
        .once('value')
        .then( countrySnap => {
          this.country.hotline = countrySnap.val().hotline
        })
    },

     // Update
     updateCountry() {

       // All fields required
       if (!this.country.hotline || !this.countryKey) {
         Materialize.toast('All fields are required', 4000)
         return
       }

       this.isSending = true

       // Update
       firebase.database()
       .ref('countries/' + this.countryKey)
       .update(this.country)
       .then( () => {
         Materialize.toast('Updated', 4000)
         this.$router.push({ name: 'Countries' })
       })
     }
  },

  // Mounted
  mounted() {
    this.collectCountry()
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Admin/CountryEdit.vue